"use client";

// Meta (Facebook/Instagram) Pixel — meowmitattoo.com
//
// Fully gated on NEXT_PUBLIC_FB_PIXEL_ID: with no ID set this renders nothing,
// window.fbq is never defined, and every fbq() call in lib/analytics.js is a
// no-op. To activate, set NEXT_PUBLIC_FB_PIXEL_ID (from Meta Events Manager)
// and redeploy — no code change needed.
//
// IG/FB is the studio's main traffic source, so the pixel is what lets Meta
// ads optimize toward Purchase and build retargeting / lookalike audiences.
import Script from "next/script";
import { usePathname, useSearchParams } from "next/navigation";
import { Suspense, useEffect, useRef } from "react";

const PIXEL_ID = process.env.NEXT_PUBLIC_FB_PIXEL_ID || "";

// App Router is a SPA — fbq auto-fires PageView only on first load. Subsequent
// client-side navigations need a manual PageView, mirroring GoogleAnalytics.js.
function PixelPageview() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (typeof window.fbq !== "function") return;
    window.fbq("track", "PageView");
  }, [pathname, searchParams]);

  return null;
}

export default function MetaPixel() {
  if (!PIXEL_ID) return null;

  return (
    <>
      {/* lazyOnload 同 GoogleAnalytics.js — 讓出 hydration 期主執行緒 */}
      <Script id="meta-pixel" strategy="lazyOnload">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${PIXEL_ID}');
          fbq('track', 'PageView');
        `}
      </Script>
      <noscript>
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          height="1"
          width="1"
          style={{ display: "none" }}
          alt=""
          src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`}
        />
      </noscript>
      <Suspense fallback={null}>
        <PixelPageview />
      </Suspense>
    </>
  );
}
